import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="bootstrap-table"
// Native implementation using Stimulus + Bootstrap 5.3
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "initialize",
    value: function initialize() {
      this.search = this.search.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this = this;
      this.rows = Array.from(this.element.querySelectorAll('tbody tr'));
      this.currentSortColumn = null;
      this.currentSortOrder = 'asc';

      // Apply initial sort if specified
      var initialSortField = this.element.dataset.sortName;
      var initialSortOrder = this.element.dataset.sortOrder || 'asc';
      if (initialSortField) {
        var header = this.element.querySelector("th[data-field=\"".concat(initialSortField, "\"]"));
        if (header) {
          this.currentSortColumn = header.cellIndex;
          this.currentSortOrder = initialSortOrder;
          this.sortTable(this.currentSortColumn, false);
          this.updateSortIndicators(header);
        }
      }

      // Make sortable headers clickable
      this.element.querySelectorAll('th[data-sortable="true"]').forEach(function (header) {
        header.style.cursor = 'pointer';
        header.addEventListener('click', function () {
          return _this.handleSort(header);
        });
      });

      // Add search input if data-search="true"
      if (this.element.dataset.search === 'true') {
        var _this$element$previou;
        this.searchContainer = (_this$element$previou = this.element.previousElementSibling) !== null && _this$element$previou !== void 0 && _this$element$previou.matches('[data-bootstrap-table-search]') ? this.element.previousElementSibling : this.createSearchInput();
        this.searchInput = this.searchContainer.querySelector('input');
        this.searchInput.addEventListener('input', this.search);
      }
    }
  }, {
    key: "createSearchInput",
    value: function createSearchInput() {
      var searchContainer = document.createElement('div');
      searchContainer.className = 'mb-3';
      searchContainer.dataset.bootstrapTableSearch = 'true';
      var searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.className = 'form-control';
      searchInput.placeholder = 'Search...';
      searchContainer.appendChild(searchInput);
      this.element.parentElement.insertBefore(searchContainer, this.element);
      return searchContainer;
    }
  }, {
    key: "handleSort",
    value: function handleSort(header) {
      var columnIndex = header.cellIndex;

      // Toggle sort order if clicking same column
      if (this.currentSortColumn === columnIndex) {
        this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSortColumn = columnIndex;
        this.currentSortOrder = 'asc';
      }
      this.sortTable(columnIndex, true);
      this.updateSortIndicators(header);
    }
  }, {
    key: "sortTable",
    value: function sortTable(columnIndex) {
      var _this2 = this;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var tbody = this.element.querySelector('tbody');
      var sortedRows = _toConsumableArray(this.rows).sort(function (a, b) {
        var _a$cells$columnIndex, _b$cells$columnIndex;
        var aCell = ((_a$cells$columnIndex = a.cells[columnIndex]) === null || _a$cells$columnIndex === void 0 ? void 0 : _a$cells$columnIndex.textContent.trim()) || '';
        var bCell = ((_b$cells$columnIndex = b.cells[columnIndex]) === null || _b$cells$columnIndex === void 0 ? void 0 : _b$cells$columnIndex.textContent.trim()) || '';

        // Try numeric comparison first
        var aNum = parseFloat(aCell);
        var bNum = parseFloat(bCell);
        if (!isNaN(aNum) && !isNaN(bNum)) {
          return _this2.currentSortOrder === 'asc' ? aNum - bNum : bNum - aNum;
        }

        // Fall back to string comparison
        var comparison = aCell.localeCompare(bCell, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
        return _this2.currentSortOrder === 'asc' ? comparison : -comparison;
      });

      // Clear and re-append rows
      tbody.innerHTML = '';
      sortedRows.forEach(function (row) {
        return tbody.appendChild(row);
      });

      // Update our reference to maintain order for filtering
      this.rows = sortedRows;
    }
  }, {
    key: "updateSortIndicators",
    value: function updateSortIndicators(activeHeader) {
      // Remove all existing sort indicators
      this.element.querySelectorAll('th[data-sortable="true"]').forEach(function (header) {
        header.classList.remove('sorted-asc', 'sorted-desc');
        var existingIcon = header.querySelector('.sort-icon');
        if (existingIcon) existingIcon.remove();
      });

      // Add indicator to active header
      var icon = document.createElement('span');
      icon.className = 'sort-icon ms-1';
      icon.innerHTML = this.currentSortOrder === 'asc' ? '▲' : '▼';
      activeHeader.appendChild(icon);
      activeHeader.classList.add("sorted-".concat(this.currentSortOrder));
    }
  }, {
    key: "search",
    value: function search(event) {
      var searchTerm = event.target.value.toLowerCase();
      this.rows.forEach(function (row) {
        var text = row.textContent.toLowerCase();
        row.style.display = text.includes(searchTerm) ? '' : 'none';
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.searchInput) {
        this.searchInput.removeEventListener('input', this.search);
      }

      // Cleanup: remove event listeners
      this.element.querySelectorAll('th[data-sortable="true"]').forEach(function (header) {
        header.replaceWith(header.cloneNode(true));
      });
    }
  }]);
}(Controller);
export { _default as default };